import React, { useState } from 'react';
import classnames from 'classnames';
import { GIVEAWAY_FEEDBACK_LIMIT, GiveawayLinkStatus } from 'swag-common/constants/giveaway.constants';
import { Button, ButtonType } from 'swag-client-common/components/ui/button/button';
import { PoweredBySwagLink } from '../../partials/powered-by-swag-link';
import classes from './info-page.scss';
export const InfoPage = ({
  primaryColor,
  logo,
  title,
  subtitle,
  dataProps,
  status,
  feedback,
  saveFeedback,
  backgroundColor
}) => {
  const [message, setMessage] = useState('');
  const handleMessageChange = e => {
    setMessage(e.target.value);
  };
  const handleMessageSubmit = () => {
    if (saveFeedback && dataProps) {
      saveFeedback(dataProps, message);
      setMessage('');
    }
  };
  const renderFeedbackForm = () => {
    const isValid = message.length > 0 && message.length <= GIVEAWAY_FEEDBACK_LIMIT;
    const shouldWeShowFeedbackBlock = status === GiveawayLinkStatus.COMPLETED && !feedback && saveFeedback;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.feedbackBlock, {
        [classes.hidden]: !shouldWeShowFeedbackBlock
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.messageTitle
    }, "Would you like to send a nice message to the sender? We will be sure to pass on the message! :)"), /*#__PURE__*/React.createElement("textarea", {
      placeholder: 'Write your note here...',
      value: message,
      onChange: handleMessageChange
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.error, {
        [classes.opened]: !isValid && message.length > 0
      })
    }, "Maximum ", GIVEAWAY_FEEDBACK_LIMIT, " symbols."), /*#__PURE__*/React.createElement(Button, {
      className: classes.button,
      style: {
        backgroundColor: primaryColor,
        borderColor: primaryColor
      },
      type: ButtonType.primary,
      disabled: !isValid,
      onClick: handleMessageSubmit
    }, "Submit"));
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: backgroundColor || primaryColor
    },
    className: classes.page,
    "data-id": dataProps
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, logo, /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, title), renderFeedbackForm(), /*#__PURE__*/React.createElement("div", {
    className: classes.subtitle
  }, subtitle), /*#__PURE__*/React.createElement(PoweredBySwagLink, {
    color: primaryColor
  })));
};